import { createSlice } from "@reduxjs/toolkit";

const restaurantsSlice = createSlice({
  name: "restaurants",
  initialState: {
    restaurants: [],
    selectedRestaurant: null,
    loading: false,
    error: null,
    pagination: {
      page: 1,
      totalPages: 1,
      total: 0,
    },
  },
  reducers: {
    setRestaurants: (state, action) => {
      state.restaurants = action.payload;
    },
    addRestaurant: (state, action) => {
      state.restaurants.unshift(action.payload);
    },
    updateRestaurant: (state, action) => {
      const index = state.restaurants.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.restaurants[index] = action.payload;
      }
    },
    deleteRestaurant: (state, action) => {
      state.restaurants = state.restaurants.filter((r) => r._id !== action.payload);
    },
    setSelectedRestaurant: (state, action) => {
      state.selectedRestaurant = action.payload;
    },
    setRestaurantsLoading: (state, action) => {
      state.loading = action.payload;
    },
    setRestaurantsError: (state, action) => {
      state.error = action.payload;
    },
    setRestaurantsPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearRestaurantsState: (state) => {
      state.restaurants = [];
      state.selectedRestaurant = null;
      state.loading = false;
      state.error = null;
      state.pagination = { page: 1, totalPages: 1, total: 0 };
    },
  },
});

export const {
  setRestaurants,
  addRestaurant,
  updateRestaurant,
  deleteRestaurant,
  setSelectedRestaurant,
  setRestaurantsLoading,
  setRestaurantsError,
  setRestaurantsPagination,
  clearRestaurantsState,
} = restaurantsSlice.actions;

export default restaurantsSlice.reducer;
